export const WA_LINK =
  'https://wa.me/56995083900?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20atenci%C3%B3n%20dental'
export const BUSINESS_NAME = 'Consulta Dental Raymon Arriagada'
